import { render, staticRenderFns } from "./AdminMallaDocente.vue?vue&type=template&id=6f622e8c&"
import script from "./AdminMallaDocente.vue?vue&type=script&lang=js&"
export * from "./AdminMallaDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports